import getColor from "@insite/mobius/utilities/getColor";
import React, { useState } from "react";
import styled from "styled-components";

interface FilterMenuProps {
  categories: string[];
  searchTerm: string;
  categoryFilters: string[];
  sortBy: string;
  handleSearchTermChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleCategoryFiltersChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSortByChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  isTabletView?: any
}

const styles = {
  searchInput: {
    color: "#17313E",
    fontSize: "1.3rem",
    lineHeight: 1.75,
    fontWeight: 400,
    fontFamily: "Lato",
    marginBottom: "1em",
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    outline: "none",
    "&:focus": {
      outline: "none",
    },
  },
  categoryLabel: {
    color: "#17313E",
    fontSize: "1.1rem",
    lineHeight: 1.5,
    fontWeight: 500,
    fontFamily: "Lato",
  },
  filterMenuWrapper: {
    padding: "1em",
  },
  filterCategoryWrapper: {
    marginBottom: "1em",
  },
  tabletSearchInput: {
    width: '8em',
  },
};

const SearchInput = styled.input(styles.searchInput);

const CategoryLabel = styled.span(styles.categoryLabel);

const FilterMenuWrapper = styled.div(styles.filterMenuWrapper);

const FilterCategoryWrapper = styled.div(styles.filterCategoryWrapper);

export const FilterMenu: React.FC<FilterMenuProps> = ({
  categories,
  searchTerm,
  categoryFilters,
  sortBy,
  handleSearchTermChange,
  handleCategoryFiltersChange,
  handleSortByChange,
  isTabletView
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <FilterMenuWrapper>
      <SearchInput
        type="text"
        placeholder="Search..."
        value={searchTerm}
        style={isTabletView ? styles.tabletSearchInput : styles.searchInput}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onChange={handleSearchTermChange}
      />
      <div>
        {categories.map((category, index) => (
          <FilterCategoryWrapper key={index}>
            <input
              type="checkbox"
              value={category}
              checked={categoryFilters.includes(category)}
              onChange={handleCategoryFiltersChange}
            />
            <CategoryLabel>{category}</CategoryLabel>
          </FilterCategoryWrapper>
        ))}
      </div>
    </FilterMenuWrapper>
  );
};
